module.exports = __webpack_public_path__ + "static/media/gender.ed32ce82.svg";